import { render } from "./VideoScripts.vue?vue&type=template&id=1883a4a1&lang=true"
import script from "./VideoScripts.vue?vue&type=script&lang=js"
export * from "./VideoScripts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__